import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { Button } from '~/ui/core/button/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '~/ui/core/dropdown-menu/DropdownMenu';
import { IconDelete, IconFileDownload } from '~/ui/core/icons';

type ActionsDropdownProps = {
    readonly disabled: boolean;
    readonly onDelete: () => void;
    readonly onDownload: () => void;
};

export const ActionsDropdown: FunctionComponent<ActionsDropdownProps> = ({ disabled, onDelete, onDownload }) => {
    const translate = useTranslate();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild={true} disabled={disabled}>
                <Button disabled={disabled} type="button" variant="secondary">
                    {translate('common.actions')}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" sideOffset={5}>
                <DropdownMenuItem onSelect={onDownload}>
                    <IconFileDownload size={16} />
                    {translate('common.download')}
                </DropdownMenuItem>
                <DropdownMenuItem onSelect={onDelete}>
                    <IconDelete size={16} />
                    {translate('common.delete')}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
